import { render, staticRenderFns } from "./integartionConfig.vue?vue&type=template&id=5a698e65&scoped=true"
import script from "./integartionConfig.vue?vue&type=script&lang=js"
export * from "./integartionConfig.vue?vue&type=script&lang=js"
import style0 from "./integartionConfig.vue?vue&type=style&index=0&id=5a698e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a698e65",
  null
  
)

export default component.exports